import { render, staticRenderFns } from "./hkindex.vue?vue&type=template&id=92e04482"
import script from "./hkindex.vue?vue&type=script&lang=js"
export * from "./hkindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports